import Link from 'next/link'
import styles from './index.module.less'

export function toDashed(str: string): string {
  return str
    .replace(/([A-Z])/g, (match) => `-${match.toLowerCase()}`)
    .replace(/_/g, '-')
    .toLowerCase()
}
interface Props {
  href: any
  name?: string
}

export const getFirstLevelPath = (path: string) => {
  if (!path) {
    return ''
  }
  // 去掉两端的斜杠
  path = path.replace(/^\/|\/$/g, '')
  // 查找第一个斜杠的位置
  const index = path.indexOf('/')
  if (index === -1) {
    // 如果没有斜杠，则直接返回原字符串
    return '/' + path
  } else {
    // 如果有斜杠，则返回第一个斜杠之前的字符串
    return '/' + path.substring(0, index)
  }
}

const LinkSeo = ({ href, name }: Props) => {
  return (
    <span className={styles.linkSeo}>
      <Link href={href}>
        <a>{name || (typeof href === 'string' ? href : '')}</a>
      </Link>
    </span>
  )
}

export default LinkSeo
